import { NgModule } from '@angular/core';
import { PocModalComponent } from "./poc-modal.component";
import { CommonModule } from "@angular/common";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { MatDialogModule } from "@angular/material/dialog";
import { CardModule } from "libraries/ui_card/card.module";


@NgModule({
    imports: [
        CommonModule,
        LoaderModule,
        MatDialogModule,
        CardModule,
    ],
    exports: [],
    declarations: [PocModalComponent],
    providers: [],
})
export class PocModalModule {
}
